<template>
    <div>
        <!-----ฟอร์มค่ามัดจำ---->
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <h2 class="text-center p-3">รายการจ่ายเงิน-มัดจำ</h2>
            <!---header--->
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">
                            วันที่จ่ายเงิน
                        </label>
                        <div class="col-sm-8">
                            <date-picker
                                v-model="form.receive_date"
                                :format="changeFormat"
                                class="w-100"
                                :disabled="disable_date"
                                :lang="lang"
                                placeholder="วันที่จ่ายเงิน">
                            </date-picker>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">
                            รหัสเจ้าหนี้
                        </label>
                        <div class="col-sm-8">
                            <multiselect
                                v-model="form.vendor"
                                :options="optionVendor"
                                :customLabel="vendorLabel"
                                placeholder="เลือกรหัสเจ้าหนี้"
                                :show-labels="false"
                                track-by="id">
                            </multiselect>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group row" v-if="form.no">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">
                            เลขที่ CS
                        </label>
                        <div class="col-sm-8">
                            <masked-input v-model="form.no"
                                          mask="CS111111111"
                                          placeholder="เลขที่ CS"
                                          class="form-control"
                                          type="text"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">
                            ยอดจ่าย
                        </label>
                        <div class="col-sm-8">
                            <input type="number" v-model="calculateTotal" class="form-control" disabled/>
                        </div>
                    </div>
                </div>
            </div>
            <!---content--->
            <div>
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th scope="col">ลำดับ</th>
                        <th scope="col" width="350px">รหัสบัญชี</th>
                        <th scope="col">รายการ</th>
                        <th scope="col" width="150px">ยอดที่จ่าย</th>
                        <th scope="col">เพิ่ม / ลบ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(detail,index) in details">
                        <td>{{ ++index }}</td>
                        <td>
                            <multiselect
                                v-model="detail.account"
                                :options="optionAccount"
                                :customLabel="LabelWithName"
                                placeholder="รหัสบัญชี"
                                :show-labels="false"
                                track-by="index">
                            </multiselect>
                            <div style="display: none"> <!---set variable form account-->
                                <template v-if="detail.account">
                                    {{ detail.index = detail.account.index }}
                                    {{ detail.account_id = detail.account.account_id }}
                                    {{ detail.account_details_id = detail.account.account_details_id }}
                                    {{ detail.payment_details_id = detail.account.payment_details_id }}
                                    {{ detail.name = detail.account.name }}
                                    {{ detail.account_number = detail.account.account_number }}
                                </template>
                                <template v-else>
                                    {{ detail.index = "" }}
                                    {{ detail.account_id = "" }}
                                    {{ detail.account_details_id = "" }}
                                    {{ detail.payment_details_id = "" }}
                                    {{ detail.name = "" }}
                                    {{ detail.account_number = null }}
                                </template>
                            </div>
                        </td>
                        <td>
                            <template v-if="detail.account">
                                {{ detail.account.name }}
                            </template>
                        </td>
                        <td>
                            <input type="number" class="form-control"
                                   v-model="detail.amount"/>
                        </td>
                        <td>
                            <!--เพิ่ม-->
                            <button type="button" class="btn btn-primary"
                                    @click="addOtherDetails"
                                    v-if="details.length == index">
                                <icon name="plus"></icon>
                            </button>
                            <!--ลบ-->
                            <button type="button" class="btn btn-danger"
                                    @click="removeOtherDetails(index)"
                                    v-if="index < details.length">
                                <icon name="trash"></icon>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-6" style="margin-right: 10px">
                <div class="form-group row">
                    <label
                        class="col-sm-4 col-form-label text-capitalize text-right">
                        หมายเหตุ
                    </label>
                    <div class="col-sm-8">
                        <textarea class="form-control"
                                  v-model="form.note">
                        </textarea>
                    </div>
                </div>
            </div>
            <br/>
            <div class="text-left" style="margin-left: 20px">
                <button class="btn btn-success"
                        @click="goToRRPayoffTransaction">บันทึก
                </button>
            </div>
            <br/>
        </div>
        <!--b-modal payment-->
        <b-modal size="lg" hide-header hide-footer ref="billing_modal">
            <div>
                <rr-payoff-transaction @submit="saveOtherRRPayoff">
                </rr-payoff-transaction>
            </div>
        </b-modal>
        <!--        <pre class="alert-danger">{{form}}</pre>-->
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import {mapState} from "vuex"
import Multiselect from "vue-multiselect";
import RrPayoffTransaction from "./RRPayoffFormTransaction";
import moment from "moment";
import MaskedInput from 'vue-masked-input'

export default {
    name: "r-r-payoff-other-form",
    props: {
        payment_type: {default: 3},
        status: {default: null}
    },
    components: {
        RrPayoffTransaction,
        DatePicker,
        Multiselect,
        MaskedInput
    },
    created() {
        //console.log("payment_type",this.payment_type);
        //console.log("status",this.status);
        if (this.form.id) {
            this.disable_date = true;
        }
        this.$store.dispatch("Vendor/getVendorAll");
        this.$store.dispatch("Account/getPaymentAccountAll");
        if (this.form.receive_date && !this.form.no && this.status == 1) {
            this.generateCSNumber();
        }
    },
    data() {
        return {
            disable_date: false,
            items: [
                {
                    text: "รายการตัดจ่าย",
                    to: {name: "rr-payoff-list"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    computed: {
        ...mapState({
            optionVendor: state => {
                return state.Vendor.vendorAll
            },
            details: state => {
                return state.RRPayoff.form.rr_payoff_other_details;
            },
            form: state => {
                return state.RRPayoff.form
            },
            optionAccount: state => {
                return state.Account.paymentAccountAll.filter(account => { //true return all
                    return !state.RRPayoff.form.rr_payoff_other_details.find(detail => { //true => return details
                        return detail.index === account.index
                    })
                })
            },
        }),
        validateSave() {
            let result = 1;
            this.details.forEach(detail => {
                //ไม่ได้ใส่ข้อมูลอะไรเลย
                if (!detail.account && !detail.amount) {
                    return result = parseFloat(result) * (1);
                }
                //มีแต่บัญชี
                else if (!detail.account && detail.amount) {
                    return result = parseFloat(result) * (0);
                }
                //มีจำนวนเงิน
                else if (detail.account && !detail.amount) {
                    return result = parseFloat(result) * (0)
                } else {
                    return result = parseFloat(result) * (1);
                }
            });
            return result;
        },
        calculateTotal() {
            let amount = 0;
            return this.details.reduce((carry, detail) => {
                amount = detail.amount
                if (!detail.amount) {
                    amount = 0
                }
                return carry + parseFloat(amount)
            }, 0);
        }
    },
    methods: {
        vendorLabel(option) {
            return `${option.vendor_id} - ${option.name}`
        },
        showBillingModal() {
            this.$refs.billing_modal.show();
        },
        hideBillingModal() {
            this.$refs.billing_modal.hide();
        },
        LabelWithName(option) {
            return `${option.account_number} - ${option.name}`
        },
        addOtherDetails() {
            this.$store.dispatch("RRPayoff/addOtherDetails");
        },
        removeOtherDetails(index) {
            this.$store.dispatch("RRPayoff/removeOtherDetails", index - 1);
        },
        goToRRPayoffTransaction() {
            if (!this.form.receive_date) {
                alert("กรุณาใส่วันที่");
            } else if (!this.form.vendor) {
                alert("กรุณาเลือกผู้จำหน่าย");
            } else if (!this.validateSave) {
                alert("กรุณาใส่ข้อมูลให้ถูกต้อง");
            } else {
                if (this.form.status == 2) {
                    this.updateCsNumber();
                } else {
                    this.form.receive_date = moment(this.form.receive_date).format("YYYY-MM-DD");
                    this.form.total_amount = this.calculateTotal;
                    this.showBillingModal();
                }
            }
        },
        updateCsNumber() {
            let data = {
                id: this.form.id,
                no: this.form.no,
            }
            this.$store.dispatch("RRPayoff/updateCsNo", data).then(() => {
                this.goToRRPayoffList();
            }).catch(() => {
                alert('ไม่สามารถอัพเดตเลข CS ได้')
            })
        },
        saveOtherRRPayoff(submitData) {
            this.form.rr_payoff_details = [];
            this.form.payoff_purchase_details = [];
            if (submitData) {
                this.form.rr_payoff_other_details = this.details;
                this.form.payment_type = this.payment_type;
                this.form.status = this.status;
                this.$store.dispatch("RRPayoff/saveRRpayoff", this.form.id).then(() => {
                    this.goToRRPayoffList();
                });
            }
            this.hideBillingModal();
        },
        goToRRPayoffList() {
            this.$router.push({
                name: "rr-payoff-list"
            })
        },
        generateCSNumber() {
            let date = moment(this.form.receive_date).format('YYYY-MM-DD');
            this.$store.dispatch("RRPayoff/generateCS", date).then(res => {
                this.form.no = res;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
thead {
    background-color: darkgrey;
    color: black;
}

tbody {
    background-color: white;
    color: black;
}
</style>
